<section
  #myAccountFormSection
  class="part-a-formio-forms"
  [class.hidden]="!formSchema"
>
  <formio
    class="d-block tabbed-steps"
    [ngClass]="[getCSSClass()]"
    [form]="formSchema"
    [submission]="submission"
    (customEvent)="fireCustomEvent($event)"
    [renderOptions]="renderOptions"
    (ready)="onFormReady($event)"
    [refresh]="refreshForm"
    *ngIf="formSchema"
  ></formio>
</section>
